import { useState, useEffect, useContext, useRef } from 'react';
import { Alert, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import AvatarEditor from 'react-avatar-editor';
import tableStyle from '../Style/TableModel.module.css';
import formStyle from '../Style/modalForm.module.css';
import button from '../Style/ButtonStyle.module.css';
import { USERS_API_BASE_URL } from './../../constants';
import AuthContext from "../../store/auth-context";
import axios from "axios";
import { getAllPlans, assignPlanToOrganization } from '../../services/organization.service';

const AddOrganisation = (props) => {
    //console.log(props.onAction)
    const authCtx = useContext(AuthContext);
    const [organisationID, setOrganisationID] = useState(0);
    const [OrganisationUUID, setOrganisationUUID] = useState('');
    const [name, setName] = useState("");
    const [custID, setCustID] = useState("");
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [phone, setPhone] = useState("");
    const [subrub, setSubrub] = useState("");
    const [state, setState] = useState("");
    const [code, setCode] = useState("");
    const [country, setCountry] = useState("");
    const [website, setWebsite] = useState("");
    const [orglogourl, setOrglogourl] = useState("");
    const [selectedFile, setSelectedFile] = useState("");
    const [selectedFileBase64, setSelectedFileBase64] = useState("");
    const [selectedPlanId, setSelectedPlanId] = useState("");
    const [plansList, setPlansList] = useState([]);
    const [isLoadingPlans, setIsLoadingPlans] = useState(false);
    const [imageError, setImageError] = useState("");
    const [showCropper, setShowCropper] = useState(false);
    const [tempFile, setTempFile] = useState(null);
    const [scale, setScale] = useState(1);
    const editorRef = useRef(null);
    
    // ePub-specific fields
    const [epubOrgId, setEpubOrgId] = useState("");
    const [orgSendgridHashid, setOrgSendgridHashid] = useState("");
    const [orgSendgridUsername, setOrgSendgridUsername] = useState("");
    const [orgSendgridPassword, setOrgSendgridPassword] = useState("");
    const [orgWistiaProjectId, setOrgWistiaProjectId] = useState("");
    const [sendgridApiKey, setSendgridApiKey] = useState("");


    const http = axios.create({
        baseURL: USERS_API_BASE_URL,
        headers: {
            "Content-type": "application/json",'Authorization':authCtx.token
        }
    });


    const OrganistionAdded = (e) => {
          e.preventDefault();
        //  console.log(name)
        //alert(organisationID);
        
        // Validate phone number - should contain at least 7 digits
        if (phone && phone.trim() !== "") {
            // Remove all non-digit characters for validation
            const digitsOnly = phone.replace(/\D/g, '');
            
            // Check if phone has at least 7 digits (minimum valid phone number length)
            if (digitsOnly.length < 7) {
                toast.error("Phone number should contain at least 7 digits");
                return;
            }
            
            // Check if phone has too many digits (max 15 for international format)
            if (digitsOnly.length > 15) {
                toast.error("Phone number should not exceed 15 digits");
                return;
            }
            
            // Ensure phone contains only valid characters
            const phoneRegex = /^[\d\s\(\)\+\-\.]+$/;
            if (!phoneRegex.test(phone)) {
                toast.error("Phone number contains invalid characters. Only numbers and (+, -, (), ., spaces) are allowed");
                return;
            }
        }
        
        if(organisationID==0){
            fetch(`${USERS_API_BASE_URL}/organisation`, {
            "method": "POST",
            "headers": {
                "Content-Type": "application/json",
                'Authorization':authCtx.token
            },
            "body":
                "{\"useruuid\":\""+ authCtx.userData.uuid +"\",\"name\":\"" + name + "\",\"custID\":" + (custID || 0) + ",\"website\":\"" + website + "\",\"phone\":\"" + phone + "\",\"streetAddress\":\"" + address + "\",\"suburb\":\"" + subrub + "\",\"state\":\"" + state + "\",\"postCode\":\"" + code + "\",\"country\":\"" + country + "\",\"email\":\"" + email + "\",\"orgLogo\":\"" + orglogourl + "\",\"epubOrgId\":" + (epubOrgId ? parseInt(epubOrgId) : null) + ",\"org_sendgrid_hashid\":\"" + (orgSendgridHashid || '') + "\",\"org_sendgrid_username\":\"" + (orgSendgridUsername || '') + "\",\"org_sendgrid_password\":\"" + (orgSendgridPassword || '') + "\",\"org_wistia_project_id\":\"" + (orgWistiaProjectId || '') + "\",\"sendgrid_api_key\":\"" + (sendgridApiKey || '') + "\"}"

            }).then(res=>res.json()).then(data=>{

                //alert(data.status==302?data.error:data.msg);props.onAction(false)

                if(data.status==302 || data.status==400){
                    // Handle error - show toast and keep modal open
                    const errorMsg = data.error || data.message || 'Failed to create organisation';
                    props.setMessage(errorMsg);
                    toast.error(errorMsg);
                }else{
                    props.setMessage(data.msg)
                    
                    // If a plan is selected, assign it to the new organization
                    if (selectedPlanId && data.neworganisationData?.uuid) {
                        assignPlanToOrganization(
                            parseInt(selectedPlanId),
                            data.neworganisationData.uuid,
                            authCtx.token
                        ).then(() => {
                            console.log('Plan assigned successfully');
                        }).catch(err => {
                            console.error('Error assigning plan:', err);
                            props.setMessage('Organization created but plan assignment failed');
                        });
                    }
                    
                    // Reload the organisation list from the server
                    fetch(`${USERS_API_BASE_URL}/organisation`, {
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            'Authorization':authCtx.token
                        }
                    }).then(res=>res.json()).then(orgData=>{
                        if(orgData && props.setOrganisationList){
                            props.setOrganisationList(orgData);
                        }
                    }).catch(err => {
                        console.error('Error reloading organisations:', err);
                    });
                    
                    // Reset form fields
                    setOrganisationID(0)
                    setName('');
                    setCustID('');
                    setEmail('');
                    setAddress('');
                    setPhone('');
                    setSubrub('');
                    setState('');
                    setCode('');
                    setCountry('')
                    setWebsite('')
                    setSelectedPlanId('');
                    setEpubOrgId('');
                    setOrgSendgridHashid('');
                    setOrgSendgridUsername('');
                    setOrgSendgridPassword('');
                    setOrgWistiaProjectId('');
                    setSendgridApiKey('');
                    props.setOrganisationDetail('');
                    
                    // Close the modal
                    props.onAction(false);
                }
            })
        }else{
            fetch(`${USERS_API_BASE_URL}/organisation/`+organisationID, {
                "method": "PUT",
                "headers": {
                    "Content-Type": "application/json",
                    'Authorization':authCtx.token
                },
                "body":
                "{\"name\":\"" + name + "\",\"custID\":" + (custID || 0) + ",\"website\":\"" + website + "\",\"phone\":\"" + phone + "\",\"streetAddress\":\"" + address + "\",\"suburb\":\"" + subrub + "\",\"state\":\"" + state + "\",\"postCode\":\"" + code + "\",\"country\":\"" + country + "\",\"email\":\"" + email + "\",\"orgLogo\":\"" + orglogourl + "\",\"epubOrgId\":" + (epubOrgId ? parseInt(epubOrgId) : null) + ",\"org_sendgrid_hashid\":\"" + (orgSendgridHashid || '') + "\",\"org_sendgrid_username\":\"" + (orgSendgridUsername || '') + "\",\"org_sendgrid_password\":\"" + (orgSendgridPassword || '') + "\",\"org_wistia_project_id\":\"" + (orgWistiaProjectId || '') + "\",\"sendgrid_api_key\":\"" + (sendgridApiKey || '') + "\"}"

            }).then(res=>res.json()).then(data=>{

                //alert(data.status==302?data.error:data.msg);props.onAction(false)

                if(data.status==302 || data.status==400){
                    // Handle error - show toast and keep modal open
                    const errorMsg = data.error || data.message || 'Failed to update organisation';
                    props.setMessage(errorMsg);
                    toast.error(errorMsg);
                }else{
                    props.setMessage(data.msg)
                    
                    // If a plan is selected, assign/update it for the organization
                    if (selectedPlanId && OrganisationUUID) {
                        assignPlanToOrganization(
                            parseInt(selectedPlanId),
                            OrganisationUUID,
                            authCtx.token
                        ).then(() => {
                            console.log('Plan updated successfully');
                        }).catch(err => {
                            console.error('Error updating plan:', err);
                            props.setMessage('Organization updated but plan assignment failed');
                        });
                    }
                    
                    if(props.organisationList){
                        const index = props.organisationList.findIndex(data => data.id === organisationID),
                        organisationData = [...props.organisationList] // important to create a copy, otherwise you'll modify state outside of setState call
                        organisationData[index] = {id:data.updateOrganisationData.id,uuid:data.updateOrganisationData.uuid, name:data.updateOrganisationData.name,createDate:data.updateOrganisationData.createDate,status:data.updateOrganisationData.status};
                        console.log(organisationData)
                        props.setOrganisationList(organisationData);
                    }
                    //setOrganisationID(0)
                    setName('');
                    setCustID('');
                    setEmail('');
                    setAddress('');
                    setPhone('');
                    setSubrub('');
                    setState('');
                    setCode('');
                    setCountry('')
                    setWebsite('')
                    setSelectedPlanId('');
                    setEpubOrgId('');
                    setOrgSendgridHashid('');
                    setOrgSendgridUsername('');
                    setOrgSendgridPassword('');
                    setOrgWistiaProjectId('');
                    setSendgridApiKey('');
                    props.setOrganisationDetail('');
                    props.onAction(false);
                }

            })
        }


    }

    
    
    const onFileUpload = async () => {
     
        // Create an object of formData
        const formData = new FormData();
        
        formData.append("organisationLogoUrl", selectedFileBase64);

        const options = {
            method: 'POST',
            body: formData,
            headers: {
              'Authorization':authCtx.token
            },
          }
          try {
            const response = await fetch(USERS_API_BASE_URL+`/organisation/org-image/${OrganisationUUID}`, options);
            //const response = await fetch(`${USERS_API_BASE_URL}/organisation/org-image/${SelecteduserUUId}`, options);
            //console.log(response)
            const json = await response.json();
            if (response.status !== 201) {
              throw new Error(json.message);
            }
            setOrglogourl(json.userProfilefilePath);
            return json;
          } catch (err) {
            //console.log('Error in upload image', err.message)
            return { error: err.message }
          }
      };
   
    const uploadImage = (file) => {
        let formData = new FormData();
        setSelectedFile(file);
        formData.append("file", file);
        http.post("/multiple-upload", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).then(function (response) {
            setOrglogourl(response.data.thumbUrl);
        });
    }

    const onFileChange = async (event) =>{
        event.preventDefault();
        setImageError("");
        let file = event.target.files[0];
        if (file) {
            const img = new Image();
            img.src = URL.createObjectURL(file);
            img.onload = () => {
                if (img.width === 400 && img.height === 400) {
                    uploadImage(file);
                } else {
                    setTempFile(file);
                    setShowCropper(true);
                    event.target.value = "";
                }
            };
        }

    }

    const handleSaveCrop = () => {
        if (editorRef.current && tempFile) {
            const canvas = editorRef.current.getImageScaledToCanvas();
            canvas.toBlob((blob) => {
                if (blob) {
                    const file = new File([blob], tempFile.name, { type: tempFile.type });
                    uploadImage(file);
                    setShowCropper(false);
                    setTempFile(null);
                }
            }, tempFile.type);
        }
    }

    const ImageThumb = ({ image }) => {
        return <img src={URL.createObjectURL(image)} style={{"width" : "80px","height":"80px"}} alt={image.name} />;
      };
   // Load plans when modal opens
   useEffect(() => {
       if (props.modalStatus && authCtx.token) {
           setIsLoadingPlans(true);
           getAllPlans(authCtx.token)
               .then((response) => {
                   if (response.data) {
                       setPlansList(response.data);
                   }
               })
               .catch((err) => {
                   console.error('Error loading plans:', err);
               })
               .finally(() => setIsLoadingPlans(false));
       }
   }, [props.modalStatus, authCtx.token]);

   useEffect(()=>{
            if(props.organisationDetail){
                setOrganisationID(props.organisationDetail.id);
                setOrganisationUUID(props.organisationDetail.uuid);
                setName(props.organisationDetail.name);
                setCustID(props.organisationDetail.custID || '');
                setEmail(props.organisationDetail.email);
                setAddress(props.organisationDetail.streetAddress);
                setPhone(props.organisationDetail.phone);
                setSubrub(props.organisationDetail.suburb);
                setState(props.organisationDetail.state);
                setCode(props.organisationDetail.postCode);
                setCountry(props.organisationDetail.country);
                setWebsite(props.organisationDetail.website);
                setOrglogourl(props.organisationDetail.logoUrl);
                setSelectedPlanId(props.organisationDetail.subscriptionPlan || "");
                
                // ePub-specific fields
                setEpubOrgId(props.organisationDetail.epubOrgId || '');
                setOrgSendgridHashid(props.organisationDetail.org_sendgrid_hashid || '');
                setOrgSendgridUsername(props.organisationDetail.org_sendgrid_username || '');
                setOrgSendgridPassword(props.organisationDetail.org_sendgrid_password || '');
                setOrgWistiaProjectId(props.organisationDetail.org_wistia_project_id || '');
                setSendgridApiKey(props.organisationDetail.sendgrid_api_key || '');
            }

   },[props.organisationDetail]);

    return (
        <>
            <Modal
                size="lg"
                show={props.modalStatus}
                onHide={props.onAction}
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <div className={formStyle.headArea}>
                    <Modal.Title id="example-modal-sizes-title-lg">
                        <h4 className={tableStyle.modalTitle}> Create New / Edit Organisation</h4>
                    </Modal.Title>
                </div>
                <form onSubmit={OrganistionAdded} >
                <div className={formStyle.bodyArea}>

                        <div className="row">
                            <div className="col-ms-12">
                                <div className={formStyle.group}>
                                    <input type="text" placeholder="Name" autoFocus title='Name' className={formStyle.formControl} value={name} onChange={e => setName(e.target.value)} required />
                                </div>
                                <div className={formStyle.group}>
                                    <input type="number" placeholder="Customer ID" title='Customer ID' className={formStyle.formControl} value={custID} onChange={e => setCustID(e.target.value)} required />
                                </div>
                                <div className={formStyle.group}>
                                    <input type="email" placeholder="Email" title='Email' className={formStyle.formControl} value={email} onChange={e => setEmail(e.target.value)} />
                                </div>
                                <div className={formStyle.group}>
                                    <input type="number" placeholder="Phone" title='Phone' className={formStyle.formControl} value={phone} onChange={e => setPhone(e.target.value)} />
                                </div>
                                <div className={formStyle.group}>
                                    <input type="text" placeholder="Street Address" title='Street Address' className={formStyle.formControl} value={address} onChange={e => setAddress(e.target.value)} />
                                </div>
                                <div className={formStyle.group}>
                                    <input type="text" placeholder="Subrub" title='Subrub' className={formStyle.formControl} value={subrub} onChange={e => setSubrub(e.target.value)} />
                                </div>
                                <div className={formStyle.group}>
                                    <input type="text" placeholder="State" title='State' className={formStyle.formControl} value={state} onChange={e => setState(e.target.value)} />
                                </div>
                                <div className={formStyle.group}>
                                    <input type="text" placeholder="Post Code" title='Post Code' className={formStyle.formControl} value={code} onChange={e => setCode(e.target.value)} />
                                </div>
                                <div className={formStyle.group}>
                                    <input type="text" placeholder="Country" title='Country' className={formStyle.formControl} value={country} onChange={e => setCountry(e.target.value)} />
                                </div>
                                <div className={formStyle.group}>
                                    <input type="text" placeholder="Website" title='Website' className={formStyle.formControl}     value={website} onChange={e => setWebsite(e.target.value)} />
                                </div>
                                <div className={formStyle.group}>
                                    <select 
                                        className={formStyle.formControl} 
                                        title='Subscription Plan'
                                        value={selectedPlanId} 
                                        onChange={e => setSelectedPlanId(e.target.value)}
                                    >
                                        <option value="">Select Subscription Plan (Optional)</option>
                                        {isLoadingPlans ? (
                                            <option disabled>Loading plans...</option>
                                        ) : (
                                            plansList.map(plan => (
                                                <option key={plan.id} value={plan.id}>
                                                    {plan.name}
                                                </option>
                                            ))
                                        )}
                                    </select>
                                </div>
                                <div className={formStyle.group}>
                                    <div style={{marginBottom:'5px'}}>Upload the School logo</div>
                                <input type="hidden" placeholder="Imgurl" className={formStyle.formControl}     value={orglogourl}  />
                                    {!showCropper ? (
                                        <>
                                        <input type="file" id="org-files" onChange={onFileChange} />
                                        {selectedFile && <ImageThumb image={selectedFile} />}
                                        {orglogourl && !selectedFile && <img src={orglogourl} style={{"width" : "80px","height":"80px"}} alt={orglogourl} />}
                                        {imageError && <div style={{color: 'red', fontSize: '12px', marginTop: '5px'}}>{imageError}</div>}
                                        </>
                                    ) : (
                                        <div style={{textAlign: 'center', background: '#f8f9fa', padding: '10px', borderRadius: '5px'}}>
                                            <AvatarEditor
                                                ref={editorRef}
                                                image={tempFile}
                                                width={400}
                                                height={400}
                                                border={2}
                                                color={[255, 155, 155, 0.6]} // RGBA
                                                scale={scale}
                                                rotate={0}
                                            />
                                            <div style={{margin: '10px 0'}}>
                                                <label style={{marginRight: '10px'}}>Zoom:</label>
                                                <input type="range" min="0.1" max="3" step="0.01" value={scale} onChange={(e) => setScale(parseFloat(e.target.value))} />
                                            </div>
                                            <button type="button" onClick={handleSaveCrop} className={`${button.smBtn} ${button.blueButton}`}>Crop & Save</button>
                                            <button type="button" onClick={() => {setShowCropper(false); setTempFile(null);}} className={`${button.smBtn} ${button.brownButton} ${button.buttonSpaceLeft}`}>Cancel</button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                </div>
                <div className={formStyle.FooterArea}>
                    {showCropper && <Alert variant='warning' style={{alignContent:'start'}} >Please save the logo image first.</Alert>}
                    <button type="button" onClick={props.onAction} className={button.btn + ' ' + button.brownButton}>Cancel</button>
                    <button type="submit" disabled={showCropper} className={button.btn + ' ' + button.blueButton + ' ' + button.buttonSpaceLeft} style={{opacity: showCropper ? 0.5 : 1, cursor: showCropper ? 'not-allowed' : 'pointer'}}>Save</button>
                </div>
                </form>
            </Modal>
        </>
    )
}
export default AddOrganisation;
